<section>
  <app-admin-page-header>
    <ng-container actions>
      @if (showCreate()) {
        <app-admin-button variant="primary" type="button" [disabled]="!canCreate()" (click)="goNewCountry()">
          New country
        </app-admin-button>
      }
    </ng-container>
  </app-admin-page-header>

  <app-admin-table>
    <thead>
      <tr>
        <th>Name</th>
        <th>Slug</th>
        <th>Status</th>
        <th style="text-align: right">Actions</th>
      </tr>
    </thead>
    <tbody>
      @if (countries().length === 0) {
        <tr>
          <td colspan="4">
            <app-admin-empty-state icon="globe" title="No countries yet" description="Create a country to get started." />
          </td>
        </tr>
      }
      @for (c of countries(); track c._id) {
        <tr>
          <td>
            <a
              class="cg-admin-table-row-link"
              [routerLink]="['/platform/countries', c._id, 'edit']"
            >
              <strong>{{ c.flagIcon }} {{ c.name }}</strong>
            </a>
          </td>
          <td><code class="cg-input--mono">{{ c.slug }}</code></td>
          <td>
            <app-status-badge [variant]="c.status === 'PUBLISHED' ? 'published' : 'draft'">
              {{ c.status || 'DRAFT' }}
            </app-status-badge>
          </td>
          <td>
            <div class="cg-admin-table-actions">
              @if (showEdit()) {
                <app-admin-button
                  variant="ghost"
                  type="button"
                  [disabled]="!canEdit()"
                  (click)="goEditCountry(c._id)"
                >
                  Edit
                </app-admin-button>
              }
              @if (showDuplicate()) {
                <app-admin-button variant="secondary" type="button" (click)="openDuplicate(c)" [disabled]="!canDuplicate()">
                  Duplicate
                </app-admin-button>
              }
              @if (showPublish()) {
                <app-admin-button variant="secondary" type="button" (click)="togglePublish(c)" [disabled]="!canPublish()">
                  {{ c.status === 'PUBLISHED' ? 'Unpublish' : 'Publish' }}
                </app-admin-button>
              }
              @if (showDelete()) {
                <app-admin-button variant="danger" type="button" (click)="remove(c)" [disabled]="!canDelete()">
                  Delete
                </app-admin-button>
              }
            </div>
          </td>
        </tr>
      }
    </tbody>
  </app-admin-table>
</section>

@if (duplicateModalOpen()) {
  <app-admin-modal title="Duplicate country" (closed)="closeDuplicate()">
    @if (duplicateLoading()) {
      <p class="cg-form-help">Loading country data…</p>
    } @else {
      <p class="cg-form-help cg-admin-field--full">
        All content and image references are copied. The new country is saved as <strong>DRAFT</strong>.
      </p>
      <div class="cg-admin-form-grid">
        <label class="cg-admin-field cg-admin-field--full">
          <span class="cg-admin-field__label">Name</span>
          <input
            class="cg-input"
            [(ngModel)]="duplicateName"
            name="duplicateName"
            autocomplete="off"
            placeholder="e.g. Germany Copy"
          />
        </label>
        <label class="cg-admin-field cg-admin-field--full">
          <span class="cg-admin-field__label">Slug (auto-generated)</span>
          <input class="cg-input cg-input--mono" [value]="duplicateSlugPreview()" readonly />
          <span class="cg-form-help">Public URL: /countries/{{ duplicateSlugPreview() || '…' }}</span>
        </label>
      </div>
      @if (duplicateError()) {
        <p class="cg-form-error" role="alert">{{ duplicateError() }}</p>
      }
      <div class="mt-4 flex flex-wrap justify-end gap-2">
        <app-admin-button variant="cancel" type="button" (click)="closeDuplicate()" [disabled]="duplicateSaving()">
          Cancel
        </app-admin-button>
        <app-admin-button
          variant="primary"
          type="button"
          (click)="confirmDuplicate()"
          [disabled]="duplicateLoading() || duplicateSaving() || !duplicateSource()"
        >
          {{ duplicateSaving() ? 'Duplicating…' : 'Duplicate & edit' }}
        </app-admin-button>
      </div>
    }
  </app-admin-modal>
}
